import React from 'react';

export default function SkeletonCard() {
  return (
    <div className="bg-white/80 dark:bg-gray-800/80 p-6 rounded-xl shadow-lg animate-pulse max-w-md mx-auto">
      <div className="h-6 bg-gray-300 dark:bg-gray-600 rounded w-1/3 mb-4"></div>
      <div className="h-4 bg-gray-300 dark:bg-gray-600 rounded w-full mb-2"></div>
      <div className="h-4 bg-gray-300 dark:bg-gray-600 rounded w-5/6 mb-4"></div>
      <div className="h-8 bg-gray-300 dark:bg-gray-600 rounded w-1/2"></div>
    </div>
  );
}
